
import { Button, LinearProgress, Grid, CardActions, Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import styled, { keyframes } from 'styled-components';
import MuiTypography from '@mui/material/Typography';
import AnimateButton from 'ui-component/extended/AnimateButton';
import rq from 'components/RedQuick';
import './DisneyComponent.scss';
import { mobileAndTabletCheck, useStutter } from './utility';
import { RedQuickVideoState } from './RedQuickVideo';
export default function DisneyComponent(props: any) {
    const theme = useTheme();
    const [showVideo, setShowVideo] = React.useState(false);
    const [timeoutEnter, setTimeoutEnter] = React.useState(null);
    const [timeoutLeave, setTimeoutLeave] = React.useState(null);
    const [loaded, setLoaded] = React.useState(false);
    const [imageLoadError, setImageLoadError] = React.useState(false);
    const [play, setPlay] = React.useState(false);
    const [currentTime, setCurrentTime] = React.useState(0);
    const [duration, setDuration] = React.useState(0);
    const currentTimeChangeDebounced = useStutter(currentTime, 200);
    useEffect(() => {
        if (showVideo) {
            if (props.onPlaying) {
                props.onPlaying({ duration, currentTime })
            }
        }
    }, [currentTimeChangeDebounced]);
    if (mobileAndTabletCheck()) {
        return (
            <div className={`lolo__panel ${props.classes || ''}`} style={props.panelStyle} onMouseEnter={() => {

            }} onMouseLeave={() => {

            }}>
                <div className="lolo__panel__img_container"
                    onClick={() => {
                        if (props.onPlay) {
                            props.onPlay();
                        }
                    }} style={{}}>
                    <img className="lolo__panel__image"
                        alt={props.altText}
                        style={imageLoadError ? {
                            visibility: 'hidden'
                        } : {

                        }}
                        onError={() => {
                            console.log('failed to load image' + props.imageSrc);
                            setImageLoadError(true);
                            setLoaded(true);
                        }}
                        src={props.imageSrc || `/image1.png`} />
                </div>
            </div>
        )
    }
    return (
        <div className={`lolo__panel ${props.classes || ''}`} style={{
            cursor: 'pointer',
            position: 'relative',
            ...(props.panelStyle || {})
        }} onMouseEnter={() => {
            const { hoverTimeout = 1000 } = props;
            timeoutLeave && clearTimeout(timeoutLeave);
            setTimeoutEnter(setTimeout(() => {
                setShowVideo(true);
                setPlay(true);
                if (props.onViewing) {
                    props.onViewing();
                }
            }, hoverTimeout));
        }} onMouseLeave={() => {
            const { hoverTimeout = 1000 } = props;
            timeoutEnter && clearTimeout(timeoutEnter);
            setTimeoutLeave(setTimeout(() => {
                setShowVideo(false);
                setPlay(false);
            }, hoverTimeout));
        }}>
            <div className="lolo__panel__img_container"
                onClick={() => {
                    if (props.onPlay) {
                        props.onPlay();
                    }
                }} style={{}}>
                <img className="lolo__panel__image"
                    alt={props.altText}
                    style={imageLoadError ? {
                        visibility: 'hidden'
                    } : {

                    }}
                    onError={() => {
                        console.log('failed to load image' + props.imageSrc);
                        setImageLoadError(true);
                        setLoaded(true);
                    }}
                    src={props.imageSrc || `/image1.png`} />

            </div>
            {showVideo && <div style={{
                position: 'absolute',
                height: 400 * (9 / 16),
                width: 400,
                zIndex: 10,
                top: -30,
                left: -30
            }}>
                <rq.RedQuickVideo onClick={() => {
                    if (props.onPlay) {
                        props.onPlay();
                    }
                }}
                    playerStyle={{
                        padding: 0,
                        backgroundColor: 'transparent'
                    }}
                    onEnded={() => {
                        setShowVideo(false);
                        setPlay(false);
                    }}
                    onStateChanged={(evt: RedQuickVideoState, prevState: RedQuickVideoState, $player: any) => {
                        setDuration(evt.duration);
                        setCurrentTime(evt.currentTime);
                    }}
                    play={play}
                    containerCls={'lolo__panel__video__container'}
                    disableBar
                    url={props.videoUrl} />
                <div className="lolo__panel__details_container">
                    <div className="lolo__panel__details_container_inner">
                        <div style={{
                            display: 'flex',
                            'flex': 1,
                            padding: 0,
                            paddingLeft: 10,
                            paddingRight: 10,
                            flexDirection: 'column'
                        }}>
                            <div style={{ paddingBottom: 3, paddingTop: 3 }}>
                                <Grid container spacing={2} justifyContent="center">
                                    <Grid item xs={12}>
                                        <LinearProgress variant="determinate" color="secondary" value={props.currentPosition ? props.currentPosition * 100 : 0} />
                                    </Grid>
                                </Grid>
                            </div>
                            <div style={{ display: 'flex', 'flex': 1, flexDirection: 'row', justifyContent: 'space-between' }}>
                                <ScaleWrap>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        sx={{
                                            borderRadius: '50%',
                                            padding: '13px',
                                            minWidth: 0,
                                            boxShadow: theme.customShadows.secondary,
                                            ':hover': {
                                                boxShadow: 'none'
                                            }
                                        }}
                                        onClick={() => {
                                            if (props.onPlay) {
                                                props.onPlay();
                                            }
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-player-play"
                                            width="16" height="16" viewBox="0 0 24 24"
                                            strokeWidth="2" stroke="#ffffff" fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M7 4v16l13 -8z" />
                                        </svg>
                                    </Button>
                                </ScaleWrap>
                                {props.onOpen && <ScaleWrap>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        sx={{
                                            borderRadius: '50%',
                                            padding: '13px',
                                            minWidth: 0,
                                            boxShadow: theme.customShadows.secondary,
                                            ':hover': {
                                                boxShadow: 'none'
                                            }
                                        }}
                                        onClick={() => {
                                            if (props.onOpen) {
                                                props.onOpen();
                                            }
                                        }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            className="icon icon-tabler icon-tabler-arrow-big-down" width="16" height="16"
                                            viewBox="0 0 24 24" strokeWidth="2" stroke="#ffffff"
                                            fill="none" strokeLinecap="round"
                                            strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M15 4v8h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z" />
                                        </svg>
                                    </Button>
                                </ScaleWrap>}

                            </div>
                            <div style={{ display: 'flex', 'flex': 1, padding: 3, paddingTop: 10, flexDirection: 'column' }}>
                                <span style={{
                                    fontSize: 20,
                                    fontWeight: 'bold',
                                    color: theme.palette.getContrastText(theme.palette.dark.dark)
                                }}>
                                    {props.title || ''}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div >
    )
}
const ScaleWrap = styled.div<{ height?: number }>`
    transform: scale(1) translateZ(0px);
    transition: all .2s;
    transform-origin: center center;
    &:hover { 
        transform: scale(0.9) translateZ(0px);
    }
    &:active { 
        transform: scale(0.8) translateZ(0px);
    }
`;